import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';

import { change } from 'redux-form';

import { uniqBy, isArray } from 'lodash';

import Snackbar from 'components/common/Snackbar';
import Button from 'components/common/Button';

import objectDiff from 'utils/objectDiff';

import ProductClaimHeader from './ProductClaimHeader';
import ProductClaimEmpty from './ProductClaimEmpty';
import ProductClaimField from './ProductClaimField';

const styles = () => ({
  button: {
    marginLeft: 8,
  },
});

class ProductClaimFieldArray extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focusedFieldValues: null,
      blurredFieldValues: null,
      snackbarOpen: false,
      snackbarEntered: false,
      cmnOrderLineIndex: null,
    };

    this.onFieldFocus = this.onFieldFocus.bind(this);
    this.onFieldBlur = this.onFieldBlur.bind(this);
    this.onSnackbarClose = this.onSnackbarClose.bind(this);
    this.onGroupedUpdateConfirm = this.onGroupedUpdateConfirm.bind(this);
    this.onSnackbarEntered = this.onSnackbarEntered.bind(this);
    this.onSnackbarExited = this.onSnackbarExited.bind(this);
    this.onPrintEditPreviewButtonClick = this.onPrintEditPreviewButtonClick.bind(this);
    this.onWindowKeyDowm = this.onWindowKeyDowm.bind(this);
    this.onCMNAttach = this.onCMNAttach.bind(this);
  }

  onWindowKeyDowm(event) {
    if (event.keyCode === 13) {
      this.onGroupedUpdateConfirm();
    }
  }

  onFieldFocus(values) {
    this.setState({ focusedFieldValues: values });
  }

  onFieldBlur(values) {
    const { formValues } = this.props;
    const { focusedFieldValues, snackbarEntered } = this.state;
    const openSnackbar = () => {
      setTimeout(() => {
        this.setState({
          snackbarOpen: true,
          blurredFieldValues: values,
        });
        window.addEventListener('keydown', this.onWindowKeyDowm);
      }, 100);
    };
    const diffValuesKeys = Object.keys(objectDiff(focusedFieldValues, values));
    const selectedOrderLines = formValues.orderLine.filter(item => item.Selected);
    if (!snackbarEntered && diffValuesKeys.length > 0 && selectedOrderLines.length === 0) {
      openSnackbar();
    }
  }

  onSnackbarClose() {
    this.setState({ snackbarOpen: false });
    window.removeEventListener('keydown', this.onWindowKeyDowm);
  }

  onGroupedUpdateConfirm(updateAll = true) {
    const { form, fields, actions } = this.props;
    const { blurredFieldValues } = this.state;
    if (blurredFieldValues) {
      if (updateAll) {
        fields.forEach((arrayField) => {
          Object.keys(blurredFieldValues).forEach((field) => {
            actions.change(form, `${arrayField}.${field}`, blurredFieldValues[field]);
          });
        });
      } else {
        fields.forEach((arrayField, index) => {
          const arrayFieldValues = fields.get(index);
          Object.keys(blurredFieldValues).forEach((field) => {
            if (!arrayFieldValues[field] || (isArray(arrayFieldValues[field]) && arrayFieldValues[field].length === 0)) {
              actions.change(form, `${arrayField}.${field}`, blurredFieldValues[field]);
            }
          });
        });
      }
    }
    this.setState({
      snackbarOpen: false,
      blurredFieldValues: null,
    });
    window.removeEventListener('keydown', this.onWindowKeyDowm);
  }

  onSnackbarEntered() {
    this.setState({ snackbarEntered: true });
  }

  onSnackbarExited() {
    this.setState({ snackbarEntered: false });
  }

  onPrintEditPreviewButtonClick({
    documentID,
    isCMN,
    cmnOrderLineIndex,
  }) {
    const { formValues, Patient, business, systemSettings, Facility, Diagnosis, Notes } = this.props;
    const orderInsuranceParam = uniqBy([
      {
        'Insurance ID': formValues.Insurances[0].value,
        Authorization: formValues.Authorization || null,
        'Authorization From': formValues['Authorization From'] || null,
        'Authorization To': formValues['Authorization To'] || null,
        Resubmission: formValues.Resubmission || null,
        'Original Ref Number': formValues['Original Ref Number'] || null,
      },
      ...formValues['Order Insurance Param'],
    ], 'Insurance ID');
    const historyState = {
      printData: {
        diagnosis: Diagnosis.filter(item => formValues['Diagnosis ID'].indexOf(item.ID) !== -1),
        patient: Patient,
        insurance: formValues.Insurances[0]
          ? Patient['Insurance Information'].find(item =>
            item.ID === formValues.Insurances[0].value)
          : {},
        orderLine: formValues.orderLine,
        business,
        systemSettings,
        facility: Facility,
        orderID: formValues.ID || 'create',
        prescriber: Patient.Prescriber.find(prescriber => prescriber.ID === formValues['Prescriber ID']),
        referralSource: Patient['Referral Source'].find(referralSource => referralSource.ID === formValues['Referral Source ID']),
        orderNotes: Notes,
        orderInsuranceParam,
      },
      isCMN: isCMN || false,
    };
    const href = !isCMN && formValues.orderLine.length > 6
      ? `/document/${documentID}?orderLines=0`
      : `/document/${documentID}`;
    const newWindow = window.open(href, '_blank');
    newWindow.historyState = historyState;
    // Listen to cmnattach event from child document creation window
    if (isCMN) {
      window.addEventListener('cmnattach', this.onCMNAttach);
      this.setState({ cmnOrderLineIndex });
    }
  }

  onCMNAttach(event) {
    const { form, actions } = this.props;
    const { cmnOrderLineIndex } = this.state;
    if (cmnOrderLineIndex !== null) {
      actions.change(form, `orderLine[${cmnOrderLineIndex}][CMN/AMB]`, event.detail['CMN/AMB']);
    }
  }

  render() {
    const {
      fields,
      form,
      Patient,
      Diagnosis,
      systemSettings,
      formValues,
      classes,
      lazyInitialized,
      disabled,
      meta,
    } = this.props;
    const { snackbarOpen } = this.state;
    const fieldsValues = fields.getAll();
    const cmnAmbFieldIndex = fieldsValues ? fieldsValues.findIndex(item => item['CMN/AMB']) : -1;
    const fieldsAccumulator = [];
    const filedsWithErrorsIndexes = [];
    if (meta.error && fieldsValues) {
      fieldsValues
        .forEach((item, index) => {
          if (fieldsAccumulator.find(field => field['HCPC S Code'] === item['HCPC S Code']
            && ((!field.Modifiers && !item.Modifiers)
              || (field.Modifiers && item.Modifiers
              && field.Modifiers.join() === item.Modifiers.join())))) {
            filedsWithErrorsIndexes.push(index);
          }
          fieldsAccumulator.push(item);
        });
    }
    return (
      <Fragment>
        <ProductClaimHeader
          buttonDisabled={fields.length === 0}
          form={form}
          Patient={Patient}
          Diagnosis={Diagnosis}
          onPrintEditPreviewButtonClick={this.onPrintEditPreviewButtonClick}
          lazyInitialized={lazyInitialized}
        />
        {fields.length === 0 ? (
          <ProductClaimEmpty />
        ) : (
          <Fragment>
            {fields.map((field, index) => {
              let groupedField = false;
              let groupedFieldFirst = false;
              let groupedFieldLast = false;
              let orField = false;
              if (fieldsValues[index]['Product ID']) {
                const nextGroupedField = fieldsValues[index + 1]
                && fieldsValues[index]['Product ID'] === fieldsValues[index + 1]['Product ID']
                && !fieldsValues[index + 1]['Is Main HCPC S Code'];
                const prevGroupedField = fieldsValues[index - 1]
                && fieldsValues[index]['Product ID'] === fieldsValues[index - 1]['Product ID']
                && !fieldsValues[index]['Is Main HCPC S Code'];

                groupedField = nextGroupedField || prevGroupedField;
                groupedFieldFirst = nextGroupedField && !prevGroupedField;
                groupedFieldLast = prevGroupedField && !nextGroupedField;
                orField = prevGroupedField
                && fieldsValues[index]['OR HCPC S Code']
                && fieldsValues[index]['OR HCPC S Code'].indexOf(fieldsValues[index - 1]['HCPC S Code ID']) !== -1;
              }

              let cmnAmbDisabled;
              if (cmnAmbFieldIndex !== -1 && cmnAmbFieldIndex !== index) {
                cmnAmbDisabled = 'selected';
              }
              if (!fieldsValues[index].ID) {
                cmnAmbDisabled = 'save';
              }

              return (
                <Fragment
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                >
                  <ProductClaimField
                    name={field}
                    form={form}
                    onRemove={() => fields.remove(index)}
                    first={index === 0}
                    groupedField={groupedField}
                    groupedFieldFirst={groupedFieldFirst}
                    groupedFieldLast={groupedFieldLast}
                    rejectedField={fieldsValues[index]['Is Rejected']}
                    orField={orField}
                    error={filedsWithErrorsIndexes.indexOf(index) !== -1}
                    cmnAmbDisabled={cmnAmbDisabled}
                    systemSettings={systemSettings}
                    Diagnosis={Diagnosis}
                    Patient={Patient}
                    {...fields.length > 1 ? {
                      onFieldBlur: this.onFieldBlur,
                      onFieldFocus: this.onFieldFocus,
                    } : {}}
                    // formValues={formValues}
                    onPrintEditPreviewButtonClick={(values) => {
                      this.onPrintEditPreviewButtonClick({
                        ...values,
                        orderLine: formValues.orderLine.filter(item =>
                          item['Product ID'] === formValues.orderLine[index]['Product ID']),
                        isCMN: true,
                        cmnOrderLineIndex: index,
                      });
                    }}
                    disabled={disabled}
                  />
                </Fragment>
              );
            })}
            <Snackbar
              open={snackbarOpen}
              variant="success"
              message="Apply update to other order lines?"
              nowrapMessage
              autoHideDuration={5000}
              resumeHideDuration={0}
              onClose={this.onSnackbarClose}
              onEntered={this.onSnackbarEntered}
              onExited={this.onSnackbarExited}
              action={(
                <Fragment>
                  <Button
                    variant="raised"
                    onClick={() => this.onGroupedUpdateConfirm(false)}
                  >
                    Update Empty
                  </Button>
                  <Button
                    className={classes.button}
                    variant="raised"
                    color="primary"
                    onClick={this.onGroupedUpdateConfirm}
                  >
                    Update All
                  </Button>
                </Fragment>
              )}
            />
          </Fragment>
        )}
      </Fragment>
    );
  }
}

ProductClaimFieldArray.propTypes = {
  form: PropTypes.string.isRequired,
  Patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  Diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  Facility: PropTypes.shape({
    ID: PropTypes.number,
  }),
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  'Order Insurance Param': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  systemSettings: PropTypes.object.isRequired,
  fields: PropTypes.shape({
    name: PropTypes.string.isRequired,
    remove: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    change: PropTypes.func.isRequired,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
  }).isRequired,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  lazyInitialized: PropTypes.bool,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    button: PropTypes.string,
  }).isRequired,
};

ProductClaimFieldArray.defaultProps = {
  Facility: null,
  business: null,
  actions: PropTypes.shape({
    change: PropTypes.func.isRequired,
  }).isRequired,
  formValues: {},
  lazyInitialized: true,
  disabled: false,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ change }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(ProductClaimFieldArray),
);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimFieldArray.js